<template>
  <div class="footer">
    <img src="../assets/img/copyright.jpg">
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
    }
  }
}
</script>

<style scoped>
img {
  width: 170px;
}
.footer {
  margin-top: 8%;
}
@media (min-width: 768px) {
  .footer {
    margin-top: 54px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue